var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class CreateResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "CorrelationId");
    /**
     */
    __publicField(this, "JobId");
    /**
     */
    __publicField(this, "SasUri");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CreateResult
     */
    __publicField(this, "$type", "V1.DataProcessingJobs.CreateResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.CorrelationId = _data["CorrelationId"];
      this.JobId = _data["JobId"];
      this.SasUri = _data["SasUri"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["CorrelationId"] = this.CorrelationId;
    _data["JobId"] = this.JobId;
    _data["SasUri"] = this.SasUri;
    return _data;
  }
}
